<template>
	<div>
		<van-field :value="value" style="display: none;"></van-field>

		<van-field :required="formCreateInject.rule.validate[0].required" readonly
			:label="formCreateInject.prop.title.title" v-model="timevalue" placeholder="" @click="show"
			input-align="right">
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
		</van-field>
		<van-calendar v-if="type=='datetimerange'" :min-date="getMinData()" :max-date="getMaxData()"
			:title="formCreateInject.prop.title.title" get-container="body" v-model="showPicker" type="range" @confirm="confirm"  />
		<van-popup :safe-area-inset-bottom="true" get-container="body" v-else v-model="showPicker" round position="bottom">
			<van-datetime-picker v-model="currentdata" :title="formCreateInject.prop.title.title" :type="format"
				@confirm="confirm" :min-date="minDate" />
		</van-popup>
	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			type: {
				default: () => {
					return 'datetimerange'
				}
			},
			format: {
				default: () => {
					return 'date'
				}
			},
			valueFormat: {
				default: () => {
					return 'timestamp'
				}
			},
			prefixIcon: {
				default: () => {
					return 'none'
				}
			},
			unlinkPanels: {
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				currentdata:this.value?this.value:new Date(),
				showPicker: false,
				timevalue: null,
				minDate:this.getMinData()
			}
		},
		created() {
			console.log(this.value)
			this.setTimevalue(this.value)

			//this.getMinData()

		},
		mounted() {
		
		},
		watch: {
			value(v) {
				this.setTimevalue(v)

			}
		},
		computed: {

		},
		methods: {
			setTimevalue(v){
				if (!v) {
					this.timevalue = null
				}else{
					if(typeof v === 'number'){
						this.formatValue(v)
					}else if(Array.isArray(v)){
						this.formatValue(v)
					}else{
						let arr = v.split(',')
						if(arr.length==1){
							this.formatValue(v)
						}else{
							this.formatValue(arr)
						}
					}
					
				}
			},
			
			
			show() {
				if (!this.disabled && !this.readonly) {
					this.showPicker = true
				}
			},
			// formatter(type, val) {
			// 	if (type === 'year') {
			// 		return `${val}年`;
			// 	} else if (type === 'month') {
			// 		return `${val}月`;
			// 	}
			// 	return val;
			// },
			getMinData() {
				let currentDate = new Date()
				let currentYear = currentDate.getFullYear()
				let tenYearsAgoYear = currentYear - 5
				return new Date(tenYearsAgoYear, currentDate.getMonth(), currentDate.getDate())
			},
			getMaxData() {
				
				let currentDate = new Date()
				let currentYear = currentDate.getFullYear()
				let tenYearsAgoYear = currentYear + 5
				return new Date(tenYearsAgoYear, currentDate.getMonth(), currentDate.getDate())
			},
			confirm(val) {
				let postvalue = this.formatValue(val)
				console.log(postvalue)
				this.$emit('input', postvalue)
				this.$emit('change', postvalue)
				this.showPicker = false
			},
			formatValue(val) {
				
				let postvalue = null
				let postarr = []
				let showarr = []
				let time = null
				if (val) {
					if (Array.isArray(val)) {
						val.forEach((item) => {
							time = item
							if(typeof time === 'object'){
								time = Date.parse(time)
							}
							if(time<1000000000000){
								postarr.push(time)
							}else{
								postarr.push(time / 1000)
							}

							showarr.push(window.systemMethods.timestampToDate(time, this
								.format ==
								'date' ?
								true : false))
						})
					
						postvalue = postarr.join(',')
						this.timevalue = showarr.join('-')
					} else {
						time = val
						if(typeof time === 'object'){
							time = Date.parse(time)
						}
						if(time<1000000000000){
							postvalue = val
						}else{
							postvalue = val / 1000
						}
						
						this.timevalue = window.systemMethods.timestampToDate(time, this.format ==
							'date' ?
							true : false)

					}
				}

				return postvalue
			}
		}
	}
</script>
